import React, { useState } from 'react'
import { Link } from 'react-router-dom'

export interface IBreadcrumb {
    title: string,
    link?: string,
    isLast?: boolean
}

interface IProps {
    breadcrumbs: Array<IBreadcrumb>
}

function Breadcrumb(props: IBreadcrumb){

    const { title, link, isLast } = props

    return(
        <>
            <div className={link ? "single-breadcrum-item" : "single-breadcrum-item no-link"}>
                {link ? <Link to={link ? link : "/"}>{title}</Link> : <p>{title}</p>}
            </div>
            {!isLast && (
                <div className="single-breadcrum-item circle">
                    <span className="breadcrumb-circle"></span>
                </div>
            )}
        </>
    )
}

export default function Breadcrumbs(props: IProps) {

    const { breadcrumbs } = props


    return(
        <div className="breadcrumbs-container">
            <div className="content-of-breadcrumbs-container">
                {breadcrumbs.map((breadcrumb: IBreadcrumb, index: number) => {
                    return <Breadcrumb {...breadcrumb} key={index} isLast={breadcrumbs.length == (index + 1) ? true : false} />
                })}
            </div>
        </div>
    )
}